<section class="page-title-area">
    <img src="assets/images/events_banner.png" alt="Page Background" class="page-bg">
    <div class="container">
        <div class="page-title-content">
            <h2>Events</h2>
        </div>
    </div>
</section>

<!-- <section class="services-details-area ptb-100">
    <div class="container">=
        <div class="scrives-item-2 mt-4" 
        style="background-color: #00000085; color: white;">
            <div class="row align-items-center">
                <div class="col-12 col-md-4 d-flex">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <img src="assets/images/solutions-details/53.png" alt="Person">
                        </div>
                    </div>
                </div>

                <div class="col-lg-8">
                    <p style="font-size: 1.5rem; color: black">Superior Digital recently conducted a Free Health Check for Apple MacBook Pro and MacBook Air devices at a leading multinational corporation. Our Apple Certified Engineers performed in-depth diagnostics, identifying potential issues and optimizing performance.</p>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <p style="font-size: 1.5rem; color: black">We also guided employees on best practices for device maintenance, security, and longevity to enhance productivity. The session provided valuable insights on storage management, battery health, software updates, and data protection. Empower your team with expert Mac assessments—contact us for a customized health check at your organisation!</p>
                </div>

                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <img src="assets/images/solutions-details/54.png" alt="Person">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <img src="assets/images/solutions-details/55.png" alt="Person">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <p style="font-size: 1.5rem; color: black">Superior Digital hosted a team get-together with our Sales, Pre-Sales Team, and Business Head to foster collaboration and align on our shared vision. The session focused on understanding each team member's strengths and expertise, enabling us to work more effectively together. </p>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <p style="font-size: 1.5rem; color: black"> We had insightful discussions on how to ensure customer service excellence by delivering the best Apple device and MDM solutions tailored to business needs. By leveraging our collective knowledge, we aim to provide seamless deployment, management, and support for Apple ecosystems. Stronger teamwork leads to better solutions—let's transform IT experiences together!</p>
                </div>

                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <img src="assets/images/solutions-details/56.png" alt="Person">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="services-details-area">
    <div class="activity-section">
        <div class="activity-row">
            <div class="activity-col image-col mobile-only">
                <h2>Superior MacBook Optimization</h2>
                <img src="assets/images/solutions-details/53.png" alt="Server Room" />
            </div>
            <div class="activity-col text-col">
                <h2 class="web-only">Superior MacBook Optimization</h2>
                <p>Superior Digital recently conducted a Free Health Check for Apple MacBook Pro and MacBook Air devices
                    at a leading multinational corporation. Our Apple Certified Engineers performed in-depth
                    diagnostics, identifying potential issues and optimizing performance.</p>
            </div>
            <div class="activity-col image-col web-only">
                <img src="assets/images/solutions-details/53.png" alt="Server Room" />
            </div>
        </div>
        
        <div class="activity-row">
            <div class="activity-col image-col mobile-only" style="display: flex; justify-content: center; align-items: center;">
                <h2>Mac Maintenance Best Practices</h2>
                <img src="assets/images/solutions-details/54.png" alt="Devices" />
            </div>
            <div class="activity-col image-col web-only">
                <img src="assets/images/solutions-details/54.png" alt="Devices" />
            </div>
            <div class="activity-col text-col ">
                <h2 class="web-only">Mac Maintenance Best Practices</h2>
                <p>We also guided employees on best practices for device maintenance, security, and longevity to enhance
                    productivity. The session provided valuable insights on storage management, battery health, software
                    updates, and data protection. Empower your team with expert Mac assessments—contact us for a
                    customized health check at your organisation!</p>
            </div>
        </div>

        <div class="activity-row">
            <div class="activity-col image-col mobile-only">
                <h2>Empowering Team Alignment</h2>
                <img src="assets/images/solutions-details/55.png" alt="Server Room" />
            </div>
            <div class="activity-col text-col">
                <h2 class="web-only">Empowering Team Alignment</h2>
                <p>Superior Digital hosted a team get-together with our Sales, Pre-Sales Team, and Business Head to
                    foster collaboration and align on our shared vision. The session focused on understanding each team
                    member's strengths and expertise, enabling us to work more effectively together.</p>
            </div>
            <div class="activity-col image-col web-only">
                <img src="assets/images/solutions-details/55.png" alt="Server Room" />
            </div>
        </div>


        <div class="activity-row">
            <div class="activity-col image-col mobile-only" style="display: flex; justify-content: center; align-items: center;">
                <h2>Elevating Apple Solutions Together</h2>
                <img src="assets/images/solutions-details/56.png" alt="Devices" />
            </div>
            <div class="activity-col image-col web-only">
                <img src="assets/images/solutions-details/56.png" alt="Devices" />
            </div>
            <div class="activity-col text-col">
                <h2 class="web-only">Elevating Apple Solutions Together</h2>
                <p>We had insightful discussions on how to ensure customer service excellence by delivering the best
                    Apple device and MDM solutions tailored to business needs. By leveraging our collective knowledge,
                    we aim to provide seamless deployment, management, and support for Apple ecosystems. Stronger
                    teamwork leads to better solutions let's transform IT experiences together!</p>
            </div>
        </div>
    </div>
</section>